import { Navigate } from 'react-router';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import { liveChannelsURL } from '@jwp/ott-common/src/utils/urlFormatting';
import type { ScreenComponent } from '@jwp/ott-ui-react/types/screens';
import useQueryParam from '@jwp/ott-ui-react/src/hooks/useQueryParam';

import MediaVideo from '../MediaVideo/MediaVideo';

const MediaLiveChannel: ScreenComponent<PlaylistItem> = ({ data, isLoading }) => {
  const play = useQueryParam('play') === '1';
  const liveChannelsId = data.liveChannelsId;

  // this live channel is part of a live channels (TV Guide) page
  if (liveChannelsId) {
    return <Navigate to={liveChannelsURL(liveChannelsId, data.mediaid, play)} replace={true}></Navigate>;
  }

  // this live channel is "just" a media item
  return <MediaVideo data={data} isLoading={isLoading} />;
};

export default MediaLiveChannel;
